import { postCredentials } from "../../../services/Admin/http/http.services"
import { setToStorage } from "../../../services/Admin/session-storage/storage.services"
import { onLoginFailure, onLoginInit, onLoginSuccess, resetErrorMsg, setErrorMsg, resetInfo, handleTokenState, resetAllUserInfo } from "./authentication.slice"
import qs from 'qs'
import { resetAllUploadInfo } from "../upload/upload.slice"
import { resetAllReportInfo } from "../reports/reports.slice"

/** Login user */
export const loginUser = (payload) => {
    return async (dispatch) => {
        dispatch(onLoginInit())
        dispatch(resetErrorMsg())
        dispatch(handleTokenState(false))
        try {
            let encPayload = qs.stringify(payload)
            console.log(encPayload);
            const result = await postCredentials('/misrecon/token', encPayload)
            console.log(result);
            dispatch(resetInfo())
            if (result.message === 'success') {
                dispatch(onLoginSuccess(result))
                dispatch(resetErrorMsg())
                setToStorage({
                    id: result.data.emp_id,
                    email: result.data.email_id,
                    accessToken: result.data.access_token,
                    name: result.data.name
                })
            } else {
                dispatch(resetInfo())
                if(result.message.includes('decrypting password'))
                dispatch(setErrorMsg('Error while decrypting password'))
                else if(result.message.includes('Invalid User'))
                    dispatch(setErrorMsg('Invalid user ID or password'))
                else if(result.message.includes('not authorized'))
                    dispatch(setErrorMsg('This ID is not authorized'))
                else
                    dispatch(setErrorMsg('Something went wrong. Unable to login'))       
            }
        } catch (error) {
            dispatch(resetInfo())
            dispatch(onLoginFailure())
            throw error
        }
    }
}

export const resetAllReduxState = () => {
    return (dispatch) => {
        dispatch(resetAllUserInfo())
        dispatch(resetAllUploadInfo())
        dispatch(resetAllReportInfo())
    }
}